import { createFeatureSelector, createSelector } from '@ngrx/store';

import { userPasswordResetFeatureKey, UserPasswordResetState } from './user-password-reset.reducer';

export const userPasswordResetFeature = createFeatureSelector<UserPasswordResetState>(userPasswordResetFeatureKey);
export const getUserPasswordResetCallState = createSelector(userPasswordResetFeature, (state) => {
   return state.callState;
});
